/**
 * Truncation helpers for content-derived strings (hotel, place and partner
 * names, addresses) whose language is unknown at render time.
 *
 * `unicode-bidi: plaintext` lets the string resolve its own base direction,
 * so the ellipsis clips its natural end instead of its start when the page
 * direction doesn't match the content (e.g. a Latin hotel name on an RTL
 * page, see sc-189345/sc-189542).
 *
 * WebKit ignores `plaintext` when placing the ellipsis and clips the start
 * anyway (sc-190596), so always pair these helpers with `dir="auto"` on the
 * element carrying the styles.
 */

/**
 * Direction isolation for truncated content. Use together with
 * `-webkit-line-clamp` truncation, or on its own for any element rendering
 * a string whose language may not match the page direction.
 */
export const isolateContentDirection = () => `
  unicode-bidi: plaintext;
`

/** Single-line ellipsis truncation for content-derived strings */
export const truncateSingleLine = () => `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${isolateContentDirection()}
`
